export const PhoneIcon = ({ primaryFontColor = '#ffd800' }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="25"
      height="25"
      viewBox="0 0 25 25"
    >
      <g id="phone-call" transform="translate(0 0)">
        <g id="Group_41404" data-name="Group 41404" transform="translate(0 0)">
          <path
            id="Path_63840"
            data-name="Path 63840"
            d="M20.484,3.513A12,12,0,1,0,24,12,12,12,0,0,0,20.484,3.513Zm-2.31,13.2,0,0v0l-.608.6a3.2,3.2,0,0,1-3.02.864A10.633,10.633,0,0,1,11.456,16.8,14.267,14.267,0,0,1,9.02,14.833,14.377,14.377,0,0,1,7.2,12.625,11.2,11.2,0,0,1,5.832,9.857a3.2,3.2,0,0,1,.8-3.268l.712-.712a.508.508,0,0,1,.718,0l0,0,2.248,2.248a.508.508,0,0,1,0,.718l0,0-1.32,1.32a1.076,1.076,0,0,0-.112,1.4,15.437,15.437,0,0,0,1.58,1.844,15.343,15.343,0,0,0,2.08,1.748,1.084,1.084,0,0,0,1.384-.12l1.276-1.3a.508.508,0,0,1,.718,0l0,0L18.172,16A.508.508,0,0,1,18.173,16.715Z"
            transform="translate(0 0)"
            fill={primaryFontColor}
          />
        </g>
      </g>
    </svg>
  );
};
